module.exports = __webpack_public_path__ + "static/media/selec-nft-6.b3266b19.png";